import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserLocation } from '@dvm-monorepo/interfaces/keycloak';
import { PaginatedResult } from '@dvm-monorepo/interfaces/pagination';
import { environment } from '@environment';

@Injectable({ providedIn: 'root' })
export class UserLocationService {
    private readonly http = inject(HttpClient);

    public getAllByUserId(userId: string): Observable<PaginatedResult<UserLocation>> {
        const url = `${environment.api}/v1/users/${userId}/locations`;
        return this.http.get<PaginatedResult<UserLocation>>(url);
    }
}
